import React from 'react';
import moment from 'moment';

const DatePickerControl = ({ id,
  field,
  value,
  includeTime,
  onChange,
  onBlur,
  ignoreOnChange,
  className,
  disabled,
  loading,
  minDate,
  maxDate,
  props,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) => {

  const inputId = id ?? "field_dp_" + field.FieldName;


  const handleOnChange = (e, field) => {
    if(!ignoreOnChange) {
      onChange(e, field);
    } else {
      const enteredMoment = moment(e.target.value);
      if (enteredMoment.isValid() && enteredMoment.year() > 1900) {
        onChange(e, field);
      }
      else if (e.target.value === '') {
        onChange(e, field);
      }
    }
  }

  return (<>
    {field?.DisplayName && (
      <label htmlFor={inputId}>
        {field.DisplayName}
        {field.IsRequired ? " *" : ""}
      </label>
    )}
    <input id={inputId}
      placeholder={field.PlaceHolder}
      onBlur={(context) => onBlur(context, field)}
      value={value??''}
      className={className}
      disabled={disabled}
      min={minDate}
      max={maxDate}
      type={!includeTime ? 'date' : 'datetime-local'}
      onChange={(e) => handleOnChange(e, field)}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
      {...props} />
  </>
  );
}

export default DatePickerControl;